import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import bulletinService from './bulletinService'
import { STATUS } from 'features/enums' 

const errorMessage = (error) => {
    return (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
  }

const initialState = {
  bulletinList: [],

  bulletinStatus: STATUS.NOT_STARTED, 
  createBulletinStatus: STATUS.NOT_STARTED, 
  deleteBulletinStatus: STATUS.NOT_STARTED, 

  viewBulletinFileInModal: false,
  currentBulletinFileView: null,

  viewBulletinUploadForm: false,
  viewBulletinPDF: false,
  selectedPDF: null,

  viewDeleteFileModal: false,
  file2Delete: null,
} 

export const uploadBulletin = createAsyncThunk(
    'bulletin/upload',
    async (data, thunkAPI) => {
      try {
        const token = thunkAPI.getState().auth.user.token
        return await bulletinService.uploadBulletin(data, token)
      } catch (error) {
      const message = errorMessage(error)
        return thunkAPI.rejectWithValue(message)
      }
    }
  )


  export const getBulletins = createAsyncThunk(
    'bulletin/get',
    async (data, thunkAPI) => {
      try {
        const token = thunkAPI.getState().auth.user.token
        return await bulletinService.getBulletins(data, token)
      } catch (error) {
      const message = errorMessage(error)
        return thunkAPI.rejectWithValue(message)
      }
    }
  )


  export const deleteBulletin = createAsyncThunk(
    'bulletin/delete',
    async (data, thunkAPI) => {
      try {
        const token = thunkAPI.getState().auth.user.token
        return await bulletinService.deleteBulletin(data, token)
      } catch (error) {
      const message = errorMessage(error)
        return thunkAPI.rejectWithValue(message)
      }
    }
  )


  export  const bulletinSlice = createSlice({
    name: 'bulletin',
    initialState,
    reducers: {
        bulletinReset: (state) => initialState,
        bulletinResetCreated: (state) => {
          state.isBulletinCreatedSuccess = false
          state.isBulletinUploading = false
          state.isBulletinCreatedError = false
          state.bulletinCreatedErrorMessage = ''
          state.selectedPDF = null
        },
        setViewBulletinUploadForm: (state, action) => { 
          state.viewBulletinUploadForm = action.payload
        },
        choosePDF: (state, action) => { state.selectedPDF = action.payload },
        setBulletinPDF: (state) => { state.showCreatePollModal = false },
        setViewBulletinFile: (state, action) => {
          state.viewBulletinFileInModal = true;
          state.currentBulletinFileView = action.payload
        },
        closeViewBulletinModal: (state, action) => {
          state.viewBulletinFileInModal = false;
          state.currentBulletinFileView = null;
        },
        setViewModal2DeleteBulletinFile: (state, action) => {
          state.viewDeleteFileModal = true;
          state.file2Delete = action.payload
        },
        closeModal2DeleteBulletinFile: (state, action) => {
          state.viewDeleteFileModal = false;
          state.file2Delete = null;
          state.deleteBulletinStatus = "NOT_STARTED"
        },
    },
    extraReducers: (builder) => {
      builder
        .addCase(uploadBulletin.pending, (state) => {
            state.createBulletinStatus = "LOADING"
        })
        .addCase(uploadBulletin.fulfilled, (state, action) => {
          state.createBulletinStatus = "SUCCESS"
          state.bulletinList.unshift( action.payload.newBulletin )
        })
        .addCase(uploadBulletin.rejected, (state, action) => {
            state.createBulletinStatus = "ERROR" 
        })
        //------------------
        .addCase(getBulletins.pending, (state) => {
          state.bulletinStatus =  "LOADING"
        })
        .addCase(getBulletins.fulfilled, (state, action) => {
          state.bulletinStatus = "SUCCESS"
          state.bulletinList = action.payload
        })
        .addCase(getBulletins.rejected, (state, action) => {
            state.bulletinStatus = "ERROR"
        })
        //------------------

        .addCase(deleteBulletin.pending, (state) => {
          state.deleteBulletinStatus = "LOADING"
        })
        .addCase(deleteBulletin.fulfilled, (state, action) => {
          state.deleteBulletinStatus = "SUCCESS"
          state.bulletinList = state.bulletinList.filter(
            (file) => file._id !== action.payload.id
          )
        })
        .addCase(deleteBulletin.rejected, (state, action) => {
            state.deleteBulletinStatus = "ERROR" 
        })
        //------------------

      },
})

export const { 
  setViewBulletinFile, 
  bulletinReset, 
  bulletinResetCreated, 
  setViewBulletinUploadForm, 
  setBulletinPDF, 
  choosePDF, 
  closeViewBulletinModal, 
  setViewModal2DeleteBulletinFile,
  closeModal2DeleteBulletinFile

} = bulletinSlice.actions
export default bulletinSlice.reducer

